import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';

@Injectable()
export class NotAllowUserGuardService implements CanActivate {
    /** Nome da propriedade para permitir acesso de usuários gerentes à rota. */
    private static ALLOW_MANAGERS_PROPERTY_NAME: string = 'allowManagers';

    constructor(
        private authTokenService: AuthTokenService,
        private router: Router,
    ) { }

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        // tslint:disable-next-line:no-bitwise
        if (this.authTokenService.role & RoleTypes.User) {
            const allowManagers: boolean = route.data[NotAllowUserGuardService.ALLOW_MANAGERS_PROPERTY_NAME];
            if (allowManagers && this.authTokenService.isUserManager) { return true; }

            this.router.navigate(['page-forbidden']);

            return false;
        }

        return true;
    }

}
